import script from "./NotificationList.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationList.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationList.vue?vue&type=style&index=0&id=afaeb7ee&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afaeb7ee"]])

export default __exports__